<script>
// Name: fb-button
import Vue from 'vue'
import Component from './component'
Vue.component(
  'fb-button',
  Component
)
</script>



// WEBPACK FOOTER //
// index.vue?aad12a94